<template>
  <div class="content">
    <div class="search">
      <i class="iconfont icon-sousuo"></i>
      <input
        type="text"
        @input="searchData"
        v-model="serData"
        placeholder="搜索老师，文章"
        @keyup.enter="searchInfo()"
      />
    </div>

    <div class="result">
      <div
        v-for="(item, index) in serList"
        :key="index"
        @click="handleClick('teacherList', item.username, 'key', item.username)"
      >
        {{ item.username }}
      </div>
    </div>
    <!-- v-if="serData != ''" -->
    <div class="" v-if="!isCreat">
      <div class="modular content-page">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>大师</div>
          </div>
        </div>
        <div class="teacher">
          <div
            v-for="(item, index) in tList"
            class="teacher-list"
            :key="index"
            style="display:flex"
            @click="teacherGo(item)"
          >
            <div class="headimg">
              <van-image
                fit="cover"
                width="100%"
                height="100%"
                :src="item.avatar"
                alt=""
              />
            </div>
            <div class="" style="flex:1">
              <div>{{ item.nickname }}</div>
              <div class="t-detail">{{ item.introduction }}</div>
            </div>
          </div>
          <div class="empty" v-if="tList.length == 0">暂无搜索数据</div>
        </div>
      </div>
      <div class="more" @click="$router.push({ path: '/teacherList' })">
        <div style="display: flex;align-items: center;">
          <i class="iconfont icon-sousuo" style="color: #ccc;"></i>
          更多大师
        </div>
        <i class="iconfont icon-a-LeftArrow"></i>
      </div>
      <div class="modular content-page">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>文章</div>
          </div>
        </div>
        <div class="article">
          <div
            class="wz"
            v-for="(item, index) in list"
            :key="index"
            @click="articleGo(item)"
          >
            <div class="wz-pos">
              <van-image
                fit="cover"
                width="100%"
                height="100%"
                :src="item.thumb"
                alt=""
              />
            </div>
            <div
              style="
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="wz-title">
                <p>{{ item.title }}</p>
              </div>
              <div class="wz-time">
                <span>{{ item.time }}</span>
                <span>已有{{ item.read }}人阅读</span>
              </div>
            </div>
          </div>
          <div class="empty" v-if="list.length == 0">暂无搜索数据</div>
        </div>
      </div>
      <div class="more" @click="$router.push('/wzlist')">
        <div style="display: flex;align-items: center;">
          <i class="iconfont icon-sousuo" style="color: #ccc;"></i>
          更多文章
        </div>
        <i class="iconfont icon-a-LeftArrow"></i>
      </div>
    </div>

    <div v-if="isCreat" class="content-page">
      <div class="modular">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>历史搜索</div>
          </div>
          <div class="look-more">
            <!-- <span>查看更多</span> -->
            <i class="iconfont icon-lajitong" @click="clear"></i>
          </div>
        </div>
        <div class="lable">
          <div @click="hisClick(item)" v-for="(item, index) in history" :key="index">{{ item }}</div>
          <div v-if="history.length == 0">暂无搜索历史</div>
        </div>
      </div>
      <!-- <div class="modular">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>热门老师</div>
          </div>
        </div>
        <div class="lable">
          <div
            v-for="(item, index) in teachers"
            :key="index"
            @click="handleClick('teacherDetails', item.id, 'id', item.username)"
          >
            {{ item.username }}
          </div>
        </div>
      </div> -->
      <!-- <div class="modular">
        <div class="modular-title">
          <div class="title-left">
            <div class="title-line"></div>
            <div>领域达人</div>
          </div>
        </div>
        <div class="lable">
          <div
            v-for="(item, index) in consult"
            :key="index"
            @click="handleClick('teacherList', item.id, 'id', item.title)"
          >
            {{ item.title }}
          </div>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
/**
@description:搜索
@createTime:2021-08-18
@create:wq
*/
export default {
  name: "",
  props: {},
  components: {},
  data() {
    return {
      teachers: [],
      consult: [],
      serList: [],
      serData: "",
      history: [],
      // list: [
      //   { title: 123, time: "3-3", read: 33 },
      //   { title: 123, time: "3-3", read: 33 },
      // ],
      list: [],
      tList: [],
      isCreat: true,
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.getTeacher();
    let h = localStorage.getItem("history")
      ? localStorage.getItem("history")
      : [];
    this.history = typeof h == "string" ? JSON.parse(h) : [];
    this.isCreat = true;
  },
  methods: {
    articleGo(item) {
      this.history.push(this.serData);
      localStorage.setItem("history", JSON.stringify(this.history));
      this.$router.push({ path: "/wzdetails", query: { id: item.id } });
    },
    teacherGo(item) {
      this.history.push(item.nickname);
      localStorage.setItem("history", JSON.stringify(this.history));
      this.$router.push({
        path: "teacherDetails",
        query: { id: item.id },
      });
    },
    clear() {
      localStorage.removeItem("history");
      this.history = [];
    },
    getTeacher() {
      this.api.getSearche().then((res) => {
        // console.log(res);
        this.teachers = res.data.teachers;
        this.consult = res.data.consult;
      });
    },
    searchData() {
      this.isCreat = false;
      if (this.serData) {
        this.api.immediateSearch({ keyword: this.serData }).then((res) => {
          // this.serList = res.data;
          this.list = res.data.articles;
          this.tList = res.data.teachers;
        });
      }
    },
    hisClick(item){
      this.serData = item;
      this.searchData();
    },
    searchInfo() {
      this.handleClick("teacherList", this.serData, "key", this.serData);
    },
    jump_page(name) {
      this.$router.push(name);
    },
    handleClick(path, item, keyname, itemName) {
      if (path && keyname) {
        this.history.push(itemName);
        localStorage.setItem("history", JSON.stringify(this.history));
        setTimeout(() => {
          this.$router.push({
            path: `/${path}`,
            query: { [keyname]: item },
          });
        }, 200);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  // margin: 0 0.24rem;
}
.content-page {
  margin-right: 0.24rem;
  margin-left: 0.24rem;
}

.search {
  margin: 0.1rem 0.24rem;
  height: 0.68rem;
  background: #f7f7f7;
  border: 1px solid #f0f0f0;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  padding: 0 0.18rem;
  i {
    font-size: 0.4rem;
    color: #cccccc;
    margin-right: 0.14rem;
  }
  input {
    flex: 1;
    height: 100%;
    border: none;
    background: transparent;
  }
}
.result {
  > div {
    height: 0.92rem;
    line-height: 0.92rem;
    font-size: 0.28rem;
    font-weight: 500;
    color: #999999;
    border-bottom: 1px solid #f0f0f0;
  }
}
.modular {
  margin-top: 0.5rem;
}
.modular-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .title-left {
    font-size: 0.32rem;
    font-weight: bold;
    color: #333333;
    display: flex;
    align-items: center;
    .title-line {
      width: 4px;
      height: 16px;
      background: linear-gradient(180deg, #4fd9d5 0%, #2fb1ad 100%);
      opacity: 1;
      border-radius: 0px 4px 4px 0px;
      margin-right: 6px;
    }
  }
  .look-more {
    font-size: 0.22rem;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
    span {
      margin-right: 6px;
    }
    i {
      font-size: 0.3rem;
    }
  }
}
.lable {
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.28rem;
  > div {
    height: 0.52rem;
    background: #f0f0f0;
    border-radius: 0.1rem;
    padding: 0 0.2rem;
    font-size: 0.24rem;
    font-weight: 500;
    color: #666666;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 0.18rem;
    margin-bottom: 0.18rem;
  }
}
.article {
  // margin: 0.4rem 0.24rem;
  width: 100%;
  background: #fff;
  .wz {
    width: 100%;
    padding: 0.32rem 0 0.26rem;
    display: flex;
    border-bottom: 1px solid #f4f4f4;
    .wz-pos {
      // flex-shrink: 0;
      width: 2.15rem;
      height: 1.62rem;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 0.32rem;
    }
    .wz-title {
      width: 100%;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
    }
    .wz-time {
      width: 100%;
      margin-top: 0.3rem;
      font-size: 0.24rem;
      font-weight: 300;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
.more {
  padding: 0.2rem 0.24rem;
  border-bottom: 2px solid #f4f4f4;
  display: flex;
  color: #aaa;
  font-size: 0.25rem;
  justify-content: space-between;
  i.icon-sousuo {
    font-size: 0.4rem;
    margin-right: 0.1rem;
  }
  .icon-a-LeftArrow {
    color: #ccc;
    font-weight: normal;
    font-size: 0.2rem;
  }
}
.teacher {
  .teacher-list {
    .headimg {
      width: 0.8rem;
      height: 0.8rem;
      border: 1px solid #000;
      border-radius: 50%;
      overflow: hidden;
      margin-right: 0.2rem;
    }
    .t-detail {
      color: #aaa;
      font-size: 0.2rem;
    }
    margin-top: 0.25rem;
    padding-bottom: 0.1rem;
    border-bottom: 1px solid #f4f4f4;
  }
}
.empty {
  width: 100%;
  margin-top: 0.2rem;
  text-align: center;
  color: #aaa;
  font-size: 0.2rem;
}
</style>
